import React, { useEffect, useRef, useState } from "react";
import { testimonials, testimonialsHeading } from "../mock";

/* parallax shift based on the section position in the viewport */
function useParallax() {
  const ref = useRef(null);
  const [shift, setShift] = useState(0);
  useEffect(() => {
    let raf = null;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const el = ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight;
        const center = rect.top + rect.height / 2;
        // ~ -1 (section below) .. +1 (section above)
        setShift((vh / 2 - center) / vh);
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return [ref, shift];
}

const Card = ({ t }) => (
  <div className="rounded-[26px] border border-dashed border-slate-300 bg-white/40 p-3.5 backdrop-blur-sm">
    <div className="rounded-2xl bg-white p-5 shadow-[0_12px_30px_rgba(20,40,70,0.06)]">
      <div className="flex items-center gap-4">
        <img
          src={t.avatar}
          alt={t.name}
          className="h-14 w-14 rounded-full object-cover ring-2 ring-[#5BA4FB]/20"
        />
        <div className="leading-tight">
          <div className="text-xl font-bold text-[#16263F]">{t.name}</div>
          <div className="mt-1 text-sm text-slate-400">{t.role}</div>
        </div>
      </div>
    </div>
    <p className="px-3 pb-2 pt-6 text-[15px] leading-7 text-slate-500">
      {t.quote}
    </p>
  </div>
);

const TestimonialsSection = () => {
  const [ref, shift] = useParallax();

  // distribute the 6 testimonials into 3 columns (2 each)
  const columns = [
    [testimonials[0], testimonials[3]],
    [testimonials[1], testimonials[4]],
    [testimonials[2], testimonials[5]],
  ];
  // each column drifts at a different rate for the dynamic feel
  const factor = [-70, 90, -45];
  const base = [0, -48, -16];

  return (
    <section
      id="testimonials"
      ref={ref}
      className="relative overflow-hidden bg-[#EDF1F8] pb-44 pt-10"
    >
      <div className="mx-auto max-w-[1180px] px-6 text-center">
        <h2 className="font-serif text-[#16263F] leading-[0.95] tracking-tight">
          <span className="block text-[9vw] md:text-[3.8rem]">
            {testimonialsHeading.line1}
          </span>
          <span className="block text-[9vw] text-[#5BA4FB] md:text-[3.8rem]">
            {testimonialsHeading.line2}
          </span>
        </h2>
      </div>

      <div className="mx-auto mt-20 grid max-w-[1180px] grid-cols-1 gap-7 px-6 md:grid-cols-3">
        {columns.map((col, i) => (
          <div
            key={i}
            className="flex flex-col gap-7 will-change-transform"
            style={{
              transform: `translateY(${base[i] + shift * factor[i]}px)`,
              transition: "transform 0.12s linear",
            }}
          >
            {col.map((t) => (
              <Card key={t.name} t={t} />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
